/**
 * L2: wallet switcher sheet (01-references §6 S4). It copies the 1Password account/collection
 * switcher: the wallet list with counts, then Settings and Lock. Vault additions: how long the app
 * has been unlocked, the replica's age, and the fixture marker.
 */
import type { AppActions, AppState } from "../contract.js";
import { cell, fakeChip, group, sheetFrame } from "../shell/chrome.js";
import { avatar, h, icon } from "../shell/dom.js";
import { switcherModel } from "../vm/switcher.js";

export function renderSwitcherSheet(state: AppState, actions: AppActions): HTMLElement {
  const m = switcherModel(state.snapshot!, state.scope, state.unlockedAt, state.now);
  const choose = (id: string | null) => () => {
    actions.setScope(id);
    actions.closeSheet();
  };
  return sheetFrame(
    "Wallets",
    actions,
    group(
      null,
      m.rows.map((r) =>
        cell({
          label: r.name,
          lead: avatar(r.name),
          detail: r.failed ? h("span", { class: "cell-detail" }, "Couldn't load") : String(r.count),
          check: r.selected,
          onClick: choose(r.id),
        }),
      ),
      {
        foot: [
          m.replica.label + (m.replica.level === "stale" ? ". This copy may be out of date." : "."),
          m.unlockedFor ? `Unlocked for ${m.unlockedFor}.` : null,
        ]
          .filter(Boolean)
          .join(" "),
      },
    ),
    group(null, [
      cell({ label: "Settings", lead: icon("gear"), chevron: true, onClick: () => { actions.closeSheet(); actions.navigate({ name: "settings" }); } }),
      cell({ label: "Lock", lead: icon("lock"), cls: "action", onClick: () => { actions.closeSheet(); actions.lock(); } }),
    ]),
    m.fixture ? h("p", { class: "sheet-note" }, fakeChip(), " Every item in this build is fake fixture data.") : null,
  );
}
